<template>
	<k-panel v-if="event">
		<template #title>
		 	{{event_start_time}} - {{event_title}}
		</template>
		<template #buttons>
<!--
				        <k-btn size="s" icon icon-name="video_library" @click="$router.push('/cloudrec/video-editor/'+uuid)"></k-btn>
		-->
					</template>
		<template #default>
			<div v-if="read_only != true">
				<k-layout responsive="768">
					<k-flex c6>
						<vod-view :uuid="uuid" :new-positions="new_positions" :key="uuid" :disable-key-events="disable_key_events"></vod-view>
					</k-flex>
					<k-flex c6>
						<template v-if="is_live">
							<live-view :uuid="uuid" v-on:clip="live_to_clip" :key="uuid"></live-view>
						</template>
					</k-flex>
				</k-layout>
			</div>
			<div v-if="account">
				<clips-view :uuid="uuid" :key="uuid" @disable-key-events="disable_key_events = $event" @position="seek_to"></clips-view>
			</div>
		</template>
	</k-panel>
</template>

<script>
import moment from 'moment'
import vueSlider from 'vue-slider-component';
import LiveView from './Live.vue';
import VodView from './Vod.vue';
import ClipsView from './Clips.vue';
import EventModel from '@/models/event.js'



export default {
	props: ["uuid"],
	components: {
		LiveView,
		VodView,
		ClipsView,
	},
	data () {
		var event_ch = this.$cloudserver.channel("events:"+this.uuid);
		return {
			ws_channel: event_ch,
			event: event_ch.data,
			in_position: undefined,
			out_position: undefined,
			new_positions: [undefined,undefined],
			disable_key_events: false,
			start: 0,
			end: 0
		}
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				console.log("DATA");
				if(typeof(newVal) != "undefined") {
					this.event = newVal;
				}
			},
			deep: true
		},
		"event": function(newVal) {
			if (typeof(newVal) != "undefined") {
				if (typeof(this.start) != "undefined" && typeof(this.end) != "undefined" && this.start != 0 && this.end != 0) {
					var start = (this.start - (this.event.cached_start_time * 1000)) / 1000.0;
					var end = (this.end - (this.event.cached_start_time * 1000)) / 1000.0;
					this.new_positions = [start, end];
				}
			}
		},
		"uuid": function(newVal) {
			this.ws_channel.leave();
			this.ws_channel = this.$cloudserver.channel("events:"+newVal);
			this.event = this.ws_channel.data;
			this.ws_channel.join();
		}
	},
	created () {
		var self = this;
		this.ws_channel.join();
	},
	mounted () {
		this.start = parseInt(this.$route.query.start,10);
		this.end = parseInt(this.$route.query.end,10);
	},
	methods: {
		back_to_list () {
			this.$router.push("/cloudrec")
		},
		live_to_clip (value) {
			this.in_position = value.position - value.length;
			this.out_position = value.position;

			this.new_positions = [this.in_position, this.out_position];
		
		},
		seek_to (value) {
			this.live_to_clip({position: value, length: 0})
		}
	},
	computed: {
		is_live () {
			return EventModel.is_current(this.event);
		},
		event_start_time() {
			var t = moment(this.event.cached_start_time * 1000);
			return t.format("L LTS");
		},
		event_title() {
			return EventModel.title(this.event);
		},
		read_only() {
			if (typeof(this.account) == "undefined") return true;
			if (typeof(this.account.meta) == "undefined") return true;
			if (this.account.meta.rec_readonly == true) {
				this.clip_filter = "all";
				return true;
			}
		},
		account () {
			return this.$store.state.account;
		}
	}
}
</script>